import { PeopleScreen } from '@/components/domain/members/PeopleScreen';

export default function PeopleVisitorsScreen() {
  return <PeopleScreen listType="visitors" />;
}
